import React, { useContext, useEffect, useState } from "react";
import "./Main.scss";
import PullToRefresh from "../PullToRefresh";
import AllForColumn2 from "../GalleryList/AllForColumn2";
import AllForColumn4 from "../GalleryList/AllForColumn4";
import { ThemeContext } from "../../store/ThemeProvider";
import { inject, observer } from "mobx-react";
import { protocol } from "../../utils/image";
import { getGalleryURL, isEmptyObj, navigatorTo } from "../../utils/util";
import { IComponentLink } from "../../component.d";
import RootStore from "../../store/RootStore";
import ListWrapper from "../Common/ListWrapper";
import { ICommonMyList } from "../Me/AllForMe";
import NoX from "../Common/NoX";
import AllForFaceDetectionDialog from "../FaceDetection/AllForFaceDetectionDialog";
import chroma from "chroma-js";
import SimpleBigPic from "../BigPic/SimpleBigPic";
import useSimpleBigPic from "../BigPic/useSimpleBigPic";
import intl from "react-intl-universal";
import { getPendantColor } from "../../utils/color";
import ReactSVG from "react-svg";

interface IDataRow {
  label: string;
  amount: number;
}
interface IRenderDataRow extends IDataRow {
  h1: string;
}
const DataRow = (props: IRenderDataRow) => (
  <div className="data-row">
    <span>{props.label}</span>
    <i style={{ color: props.h1 }}>{props.amount}</i>
    <span>{intl.get("Unit Piece")}</span>
  </div>
);

interface IHead {
  id: number;
  src: string;
  name: string;
  status?: string;
  style?: React.CSSProperties;
  amounts: IDataRow[];
  edit: () => void;
  onUnfollow?: () => void;
  onFollow?: () => void;
}
export const MyPhotosHeadBlock = (props: IHead) => {
  const { status = "self", name, src, edit } = props;
  const { h2Color, h1Color, mainColor, componentColor } =
    useContext(ThemeContext);

  const [backColor, foreColor] = getPendantColor(mainColor);

  return (
    <div className="head" style={props.style}>
      <div className="avatar-row">
        {src ? (
          <img alt="" className={"avatar"} src={src} />
        ) : (
          <ReactSVG
            src={require("../../svg/plus.svg")}
            className={"avatar the-add"}
            style={{
              color: mainColor,
              backgroundColor: "rgba(0, 0, 0, 0.1)",
            }}
            onClick={status == "self" || status == "follow" ? edit : () => {}}
          />
        )}
        <div className="avatar-row-right">
          <div className="name-row">
            {name ? <div className="name">{name}</div> : null}
            {status == "self" || status == "follow" ? (
              <div
                className="modify"
                style={{ color: mainColor }}
                onClick={edit}
              >
                {intl.get("Modify")}
              </div>
            ) : null}
            {status && status != "self" ? (
              <div
                className="avatar-follow"
                style={{ color: mainColor }}
                onClick={
                  status === "follow" ? props.onUnfollow : props.onFollow
                }
              >
                {status === "follow"
                  ? intl.get("Unfollow")
                  : intl.get("Follow")}
              </div>
            ) : null}

            <a
              onClick={() => {
                let event = new Event("show-person-share");
                event.data = props.id;
                window.dispatchEvent(event);
              }}
              className="person-status-share"
              style={{ background: mainColor, color: foreColor }}
            >
              {intl.get("Share")}
            </a>
          </div>
          <div className="tips" style={{ color: h2Color }}>
            <p>
              1、{intl.get("You can view all your photos in the history album")}
            </p>
            <p>2、{intl.get("The photos are automatically updated")}</p>
          </div>
        </div>
      </div>

      <div
        className="data-rows"
        style={{
          backgroundColor: chroma(componentColor).brighten(0.1).css(),
          color: h2Color,
        }}
      >
        {props.amounts.map((one, index) => (
          <DataRow
            key={index}
            label={one.label}
            amount={one.amount}
            h1={h1Color}
          />
        ))}
      </div>
    </div>
  );
};

interface IOneGalleryWithTitle {
  title: string;
  style?: React.CSSProperties;
  id: string;
  list: any;
  gallery: any;
  column?: string;
  onClickTitle?: any;
  h1Color?: string;
  mainColor?: string;
  imgClick: ({ index, id }: { index?: number; id: number }) => void;
  lazy?: boolean;
}
export const OneGalleryWithTitle = (props: IOneGalleryWithTitle) => {
  let {
    gallery,
    column = "2",
    onClickTitle,
    mainColor,
    h1Color,
    lazy = true,
  } = props;
  return (
    <div className="one-gallery-with-title" style={props.style}>
      <div className="title-row">
        <div className={"title"} style={{ color: h1Color }}>
          {props.title}
        </div>
        <div
          className="in"
          style={{ color: mainColor }}
          onClick={
            onClickTitle
              ? onClickTitle
              : () =>
                  navigatorTo({
                    type: "custom",
                    value: getGalleryURL(props.id, gallery.isold),
                  } as IComponentLink)
          }
        >
          {intl.get("Go")}
        </div>
      </div>
      <div className={"gallery-list"}>
        {column == "2" ? (
          <AllForColumn2
            list={props.list}
            onClick={props.imgClick}
            lazy={lazy}
          />
        ) : null}
        {column == "4" ? (
          <AllForColumn4 list={props.list} onClick={props.imgClick} />
        ) : null}
      </div>
    </div>
  );
};

interface IMyGalleryWithTitle {
  title: string;
  style?: React.CSSProperties;
  id: string;
  list: any;
  gallery: any;
  column?: string;
  onClickTitle?: any;
  h1Color?: string;
  h2Color?: string;
  mainColor?: string;
  columnsClick: ({ index, id }: { index?: number; id: number }) => void;
}
export const MyGalleryWithTitle = (props: IMyGalleryWithTitle) => {
  let {
    gallery,
    column = "2",
    onClickTitle,
    mainColor,
    h1Color,
    h2Color,
    columnsClick,
  } = props;
  return (
    <div className="my-gallery-with-title" style={props.style}>
      <div
        className="title-row"
        onClick={
          onClickTitle
            ? onClickTitle
            : () =>
                navigatorTo({
                  type: "custom",
                  value: getGalleryURL(props.id, gallery.isold),
                } as IComponentLink)
        }
      >
        <div
          className="point"
          style={{ borderColor: mainColor, background: "transparent" }}
        />
        <div className={"title"} style={{ color: h1Color }}>
          {props.title}
        </div>
        <div className="in">
          <span className="icon-right-arrow" style={{ color: h2Color }} />
        </div>
      </div>
      <div className={"gallery-list"}>
        {column == "2" ? (
          <AllForColumn2 list={props.list} onClick={columnsClick} />
        ) : null}
        {column == "4" ? (
          <AllForColumn4 list={props.list} onClick={columnsClick} />
        ) : null}
      </div>
    </div>
  );
};

interface IMyPhotosMain extends ICommonMyList {
  rootStore?: RootStore;
  eventName: string;
}

const Main = function (props: IMyPhotosMain) {
  const { backgroundColor, componentColor, h1Color, h2Color, mainColor } =
    useContext(ThemeContext);

  let { relationStore } = props.rootStore!;
  let { myself, myselfAlbum } = relationStore;

  let { data = {}, total } = myselfAlbum;

  const editClick = () => {
    setShowFaceDialog(true);
  };

  const unfollow = () => {};

  const follow = () => {};
  const { list, columnsClick, setBigIndex, bigIndex, loadBigPic, loadFinish } =
    useSimpleBigPic(data);
  const [showFaceDialog, setShowFaceDialog] = useState(false);
  return (
    <div className="my-photos-main" style={{ backgroundColor, color: h1Color }}>
      <ListWrapper
        onRefresh={props.refresh}
        onLoadMore={props.loadMore}
        eventName={props.eventName}
        scrollerChildrenSelector={".my-photos-main"}
        total={total}
      >
        <>
          <MyPhotosHeadBlock
            id={Number(myself.id)}
            src={protocol(myself.faceurl)}
            name={myself.name}
            style={{ backgroundColor: componentColor }}
            edit={editClick}
            onUnfollow={unfollow}
            onFollow={follow}
            amounts={[
              {
                label: intl.get("current album"),
                amount: myself.total_image || 0,
              },
              {
                label: intl.get("History album"),
                amount: myself.total_gallery_image || 0,
              },
            ]}
          />
          {!isEmptyObj(data) ? (
            Object.keys(data)
              .sort((a: string, b: string) => {
                return Number(a) > Number(b) ? -1 : 1;
              })
              .sort((a: string, b: string) => {
                return String(a) == String(window.gallery.id) ? -1 : 1;
              })
              .map((key: string) => {
                // @ts-ignore
                let it = data[key];
                return (
                  <OneGalleryWithTitle
                    key={it.isold ? key : it.link}
                    id={it.isold ? it.id || key : it.link}
                    gallery={it}
                    list={it.images}
                    title={it.name}
                    style={{ backgroundColor: componentColor }}
                    mainColor={mainColor}
                    imgClick={columnsClick}
                  />
                );
              })
          ) : (
            <NoX text={intl.get("No photos")} />
          )}
        </>
      </ListWrapper>
      {showFaceDialog && (
        <AllForFaceDetectionDialog
          hide={() => setShowFaceDialog(false)}
          personStatus={{ status: "self", id: 0, faceurl: "" }}
        />
      )}
      <SimpleBigPic
        pageType="MyPhoto"
        index={bigIndex}
        list={list}
        setIndex={setBigIndex}
        loadBigPic={loadBigPic}
        loadFinish={loadFinish}
      />
    </div>
  );
};

export default inject("rootStore")(observer(Main));
